<template>
  <div
    :class="{
      column: true,
      'mx-2': true,
      'drop-over': dragOver,
      dragging: dragging
    }"
  >
    <v-sheet elevation="3" class="column-title text-black-50 px-2 py-1">
      <div class="text-uppercase">
        {{ title }} ({{ sortedProjects.length }})
      </div>
      <span>{{ description }}</span>
    </v-sheet>
    <div style="height: 100%" class="column-group">
      <draggable
        :value="sortedProjects"
        @input="onDrag"
        group="people"
        @start="drag = true"
        @end="drag = false"
        v-if="$mq !== 'sm' && $mq !== 'md'"
      >
        <ProjectTile
          v-for="p in sortedProjects"
          :key="p._id"
          :project="p"
          class="mt-2 item"
          @update="$emit('update')"
        />
      </draggable>
      <div v-else>
        <ProjectTile
          v-for="p in sortedProjects"
          :key="p._id"
          :project="p"
          class="mt-2 item"
          @update="$emit('update')"
        />
      </div>
    </div>
    <v-snackbar v-model="error">{{ errorMessage }}</v-snackbar>
  </div>
</template>

<script>
import ProjectTile from "./ProjectTile";
import draggable from "vuedraggable";
import { fetchHil } from "../utils";

export default {
  name: "ProjectsColumn",
  components: {
    ProjectTile,
    draggable
  },
  props: [
    "title",
    "projects",
    "progress",
    "readOnly",
    "canUpdate",
    "update",
    "dragging",
    "description"
  ],
  data: function() {
    return {
      dragOver: false,
      error: false,
      errorMessage: ""
    };
  },
  methods: {
    onDrag(newProjects) {
      let columnOrder = {};
      newProjects.forEach((p, i) => {
        columnOrder[p._id] = i;
      });
      const stored = localStorage.getItem("ordered_projects");
      const orderByColumn = stored != null ? JSON.parse(stored) : {};
      orderByColumn[this.title] = columnOrder;
      localStorage.setItem("ordered_projects", JSON.stringify(orderByColumn));
      this._computedWatchers.sortedProjects.run();
      this.$forceUpdate();
    }
  },
  computed: {
    sortedProjects: {
      get() {
        const orderByColumn = localStorage.getItem("ordered_projects");
        let order = {};
        if (orderByColumn != null) {
          const dat = JSON.parse(orderByColumn);
          if (dat[this.title] != null) {
            order = dat[this.title];
          }
        }
        const data = this.projects.slice();
        return data.sort((a, b) => {
          if (order[a._id] !== undefined && order[b._id] !== undefined) {
            return order[a._id] - order[b._id];
          } else if (order[a._id] !== undefined) {
            return 1;
          } else if (order[b._id] !== undefined) {
            return -1;
          } else {
            return 0;
          }
        });
      },
      async set(value) {
        const orig = this.sortedProjects;
        for (let v of value) {
          if (orig.indexOf(v) !== -1) {
            continue;
          }
          if (this.canUpdate && !this.canUpdate(v)) {
            this.error = true;
            this.errorMessage = "Impossible d'affecter à cette colonne";
            return false;
          }
          try {
            await fetchHil(`/lease/${v._id}`, {
              method: "POST",
              body: this.update(v)
            });
          } catch (e) {
            console.error(e);
            this.error = true;
            this.errorMessage = "Une erreur a eu lieu";
          }

          this.$emit("update");
        }
      }
    }
  }
};
</script>

<style scoped>
.column {
  width: 260px;
  flex: 1 0 260px;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.3) 90%,
    rgba(255, 255, 255, 0.1)
  );
  min-height: calc(100vh - 200px);
  position: relative;
}
.column.dragging {
  opacity: 0.8;
}
.column-title {
  width: 100%;
  border-bottom: 3px solid #ff7c5d;
  margin-bottom: 15px;
  font-size: 12px;
}

.column-title div {
  text-align: center;
  color: #ff7c5d;
}
.column-title span {
  display: block;
  min-height: 15px;
  text-align: center;
  font-size: 0.8rem;
  color: #666;
}
</style>
